import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function formValueContainsLowerCaseValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regex = /[a-z]/;
    return regex.test(control.value) ? null : { NoContainLowerCase: true };
  };
}
